export const SAVE_COLLECTIONS = 'SAVE_COLLECTIONS'
export const SAVE_FEATURED = 'SAVE_FEATURED'
export const SAVE_PARTNER_COMPANIES = 'SAVE_PARTNER_COMPANIES'
export const SAVE_TEAM_MEMBERS = 'SAVE_TEAM_MEMBERS'
